module.exports = __webpack_public_path__ + "static/media/propx-login.4383ef4e.svg";